/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .directive('accCurrentNodeActions', [
        'FileUploadModal',
        'nodeCreateFileModal',
        'nodeInviteModal',
        'nodeMembersModal',
        'template',
        function (FileUploadModal, nodeCreateFileModal, nodeInviteModal, nodeMembersModal, template) {
            return {
                scope: true,
                replace: true,
                templateUrl: template('nodes/_current_node_actions'),
                resolve: {
                    node: ['$scope', function ($scope) { return $scope.currentNode; }]
                },
                controller: ['$scope', function ($scope) {
                    $scope.$watch('currentNode', function (currentNode) {
                        $scope.node = currentNode;
                    });

                    $scope.openCreateFileDialog = function () {
                        nodeCreateFileModal($scope.currentNode);
                    };

                    $scope.openInviteDialog = function () {
                        nodeInviteModal($scope, {
                            reloadCurrent: true
                        });
                    };

                    $scope.openMembersDialog = function () {
                        nodeMembersModal($scope, {
                            reloadCurrent: true
                        });
                    };

                    $scope.openUploadDialog = function () {
                        FileUploadModal($scope.currentNode);
                    };
                }]
            };
        }]);
